import React from 'react';
import { Link } from 'react-router-dom';
import './SitemapPage.css'; // Import the new Theme-Aware CSS

// Data Structure
const sitemapData = [
  {
    name: "Core Pages",
    type: "folder",
    children: [
      { name: "Home", url: "/", type: "file" },
      { name: "Pricing & Plans", url: "/pricing", type: "file", priority: "High" },
      { name: "Login / Authentication", url: "/login", type: "file" },
      { name: "User Dashboard", url: "/account", type: "file", protected: true },
    ]
  },
  {
    name: "Mockup Generators",
    type: "folder",
    children: [
      { name: "Apparel (T-Shirts, Hoodies)", url: "/apparel", type: "file" },
      { name: "Home & Living (Mugs, Pillows)", url: "/home-living", type: "file" },
      { name: "Tech & Social Media", url: "/tech-social", type: "file" },
    ]
  },
  {
    name: "AI Tools Suite",
    type: "folder",
    children: [
      { name: "Tools Hub", url: "/tool", type: "file" },
      { name: "Background Remover", url: "/app/tool/background-remove", type: "file" },
      { name: "Background Replacer", url: "/app/tool/background-replacer", type: "file" },
      { name: "Background Blur", url: "/app/tool/blur-background", type: "file" },
      { name: "Image Converter", url: "/app/tool/image-converter", type: "file" },
    ]
  },
  {
    name: "Company Resources",
    type: "folder",
    children: [
      { name: "About Us", url: "/about-us", type: "file" },
      { name: "Blog", url: "/blog", type: "file" },
      { name: "Contact Support", url: "/contact-us", type: "file" },
      { name: "Frequently Asked Questions", url: "/faq", type: "file" },
    ]
  },
  {
    name: "Legal & Compliance",
    type: "folder",
    isLegal: true,
    children: [
      { name: "Terms & Conditions", url: "/terms", type: "file" },
      { name: "Privacy Policy", url: "/privacy", type: "file" },
      { name: "Refund Policy", url: "/refund", type: "file" },
    ]
  }
];

// --- SVG ICONS (Styled via CSS Classes now) ---
const Icons = {
  Folder: () => (
    <svg className="icon-folder" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
    </svg>
  ),
  File: () => (
    <svg className="icon-file" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
      <polyline points="13 2 13 9 20 9"></polyline>
    </svg>
  ),
  Lock: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{color: 'var(--text-subtle)', marginLeft: '6px'}}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </svg>
  ),
  Check: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  )
};

export default function SitemapPage() {
  return (
    <div className="sitemap-container">
      
      {/* HEADER SECTION */}
      <div className="sitemap-header-section">
        <div className="status-badge">
            <Icons.Check /> Valid Structure
        </div>
        
        <h1 className="sitemap-title">Sitemap</h1>
        <p className="sitemap-desc">
            A comprehensive hierarchical index of the FullMockup platform. All pages are active, crawlable, and organized by function.
        </p>
        
        <div className="sitemap-actions">
            <a href="/sitemap.xml" className="btn-sitemap btn-dark">
                Download XML
            </a>
            <a href="/robots.txt" target="_blank" rel="noreferrer" className="btn-sitemap btn-light">
                View Robots.txt
            </a>
        </div>
      </div>

      {/* THE FILE TREE */}
      <div className="sitemap-tree">
        
        {/* Root Node */}
        <div className="root-node">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            fullmockup.com (Root)
        </div>

        {/* Tree Branches */}
        <div className="tree-lines">
            {sitemapData.map((folder, index) => (
                <div key={index} className={`folder-group ${folder.isLegal ? 'legal-highlight' : ''}`}>
                    <div className="folder-header">
                        <Icons.Folder />
                        {folder.name}
                    </div>
                    <ul className="file-list">
                        {folder.children.map((file, fIndex) => (
                            <li key={fIndex} className="file-item">
                                <Link to={file.url} className="file-link">
                                    <Icons.File />
                                    {file.name}
                                    {file.priority && <span className="badge-priority">{file.priority}</span>}
                                    {file.protected && <Icons.Lock />}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
      </div>

    </div>
  );
}